import { FTLBidsRepository } from '../repositories/ftl_bids.repository'
import {
    EnterCarrierDataParamsT,
    EnterCostPriceParamsT,
    EnterCostToBePaidParamsT,
    FTLBidGetResponseT,
    FTLBidsGetListParamsT,
    FTLBidsGetListResponseT,
    ChangeStatusParamsT,
    EnterCommentParamsT,
    FTLBidsGetExcelParamsT,
    FtlGetListParams,
    FtlIntracityGetListResponse,
    EnterCarrierDataIntracityParams,
    FtlIntracityGetQuantityParams,
    FtlIntracityGetQuantityResponse,
    FtlGetListParamsCamel,
    FtlOrderSendRequestForPaymentPayload,
} from '../types/ftl_bids.types'
import {
    CompleteIntracityPayload,
    EnterDeliveredDataIntracityPayload,
    StatusToCompletedPayload,
} from '@/core/types/additional_services.types'
import { FTLOrderDownloadResponseT } from '@/core/types/couriers.types'

const ftlBidsRepository = new FTLBidsRepository()

export class FTLBidsService {
    async getList(params?: FTLBidsGetListParamsT): Promise<FTLBidsGetListResponseT> {
        const response = await ftlBidsRepository.getList(params)
        return response.data
    }

    async getFtlList(params?: FtlGetListParamsCamel): Promise<FtlIntracityGetListResponse> {
        const response = await ftlBidsRepository.getFtlList(params)
        return response.data
    }

    async getListIntracity(params?: FtlGetListParams): Promise<FtlIntracityGetListResponse> {
        const response = await ftlBidsRepository.getListIntracity(params)
        return response.data
    }

    async getFTLBid(id: number): Promise<FTLBidGetResponseT> {
        const response = await ftlBidsRepository.getFTLBid(id)
        return response.data
    }

    async updateFTLBid(id: number, form_data: FormData): Promise<void> {
        await ftlBidsRepository.updateFTLBid(id, form_data)
    }

    async enterCostPrice(params: EnterCostPriceParamsT): Promise<void> {
        await ftlBidsRepository.enterCostPrice(params)
    }

    async enterCostToBePaid(params: EnterCostToBePaidParamsT): Promise<void> {
        await ftlBidsRepository.enterCostToBePaid(params)
    }

    async enterComment(id: number, params: EnterCommentParamsT): Promise<void> {
        await ftlBidsRepository.enterComment(id, params)
    }

    async enterCarrierData(params: EnterCarrierDataParamsT): Promise<void> {
        await ftlBidsRepository.enterCarrierData(params)
    }

    async enterCarrierDataIntracity(params: EnterCarrierDataIntracityParams): Promise<void> {
        await ftlBidsRepository.enterCarrierDataIntracity(params)
    }

    async enterDeliveryData(id: number, params: FormData): Promise<void> {
        await ftlBidsRepository.enterDeliveryData(id, params)
    }

    async enterDeliveryDataIntracity(
        id: number,
        params: EnterDeliveredDataIntracityPayload
    ): Promise<void> {
        await ftlBidsRepository.enterDeliveryDataIntracity(id, params)
    }

    async enterCompletedData(id: number, payload?: StatusToCompletedPayload): Promise<void> {
        await ftlBidsRepository.enterCompletedData(id, payload)
    }

    async completeIntracity(id: number, payload?: CompleteIntracityPayload): Promise<void> {
        await ftlBidsRepository.completeIntracity(id, payload)
    }

    async changeStatus(params: ChangeStatusParamsT): Promise<void> {
        await ftlBidsRepository.changeStatus(params)
    }

    async changeStatusFTLOrder(id: number, payload: FormData): Promise<void> {
        await ftlBidsRepository.changeStatusFTLOrder(id, payload)
    }

    async exportDeclaration(id: number, payload: FormData): Promise<void> {
        await ftlBidsRepository.exportDeclaration(id, payload)
    }

    async crossBorder(id: number, payload: FormData): Promise<void> {
        await ftlBidsRepository.crossBorder(id, payload)
    }

    async sendD24(id: number): Promise<void> {
        const response = await ftlBidsRepository.sendD24(id)
        return response.data
    }

    async createFtl(ftl_bid_payload: FormData): Promise<void> {
        const response = await ftlBidsRepository.createFtl(ftl_bid_payload)
        return response.data
    }

    async resendOneC(id: number): Promise<void> {
        await ftlBidsRepository.resendOneC(id)
    }

    async exportExcel(id: number): Promise<FTLOrderDownloadResponseT> {
        const response = await ftlBidsRepository.exportExcel(id)
        return response.data
    }

    async uploadCustomPaymentDocument(file: File): Promise<{ data: { path: string } }> {
        const response = await ftlBidsRepository.uploadCustomPaymentDocument(file)
        return response.data
    }

    async exportBids(params: FTLBidsGetExcelParamsT): Promise<Blob> {
        const response = await ftlBidsRepository.exportBids(params)
        return response.data
    }

    async exportFtlIntracity(params: FtlGetListParams): Promise<Blob> {
        const response = await ftlBidsRepository.exportFtlIntracity(params)
        return response.data
    }

    async exportAccountantFtlIntracity(params: FtlGetListParams): Promise<Blob> {
        const response = await ftlBidsRepository.exportAccountantFtlIntracity(params)
        return response.data
    }

    async printFtlBidInvoices(bid_id: number): Promise<any> {
        const response = await ftlBidsRepository.printFtlBidInvoices(bid_id)
        return response.data
    }

    async printLogistBid(bid_id: number): Promise<any> {
        const response = await ftlBidsRepository.printLogistBid(bid_id)
        return response.data
    }

    async printFtlBidWaypointInvoice(bid_id: number, waypoint_index: number): Promise<any> {
        const response = await ftlBidsRepository.printFtlBidWaypointInvoice(bid_id, waypoint_index)
        return response.data
    }

    async checkAvr(order_id: number): Promise<{ data: { isPosted: boolean } }> {
        const response = await ftlBidsRepository.checkAvr(order_id)
        return response.data
    }

    async getQuantity(
        params?: FtlIntracityGetQuantityParams
    ): Promise<FtlIntracityGetQuantityResponse> {
        const response = await ftlBidsRepository.getQuantity(params)
        return response.data
    }

    async sendRequestForPayment(id: number, payload: FtlOrderSendRequestForPaymentPayload): Promise<void> {
        const response = await ftlBidsRepository.sendRequestForPayment(id, payload)
        return response.data
    }
}
